import $ from 'jquery';

const WebServicePost = (restPath, payload, callbackSuccess = ()=>{}, callbackError = ()=>{}) => {

  $.ajax(
    {
      type: 'POST',
      url: restPath,
      xhrFields: {
        withCredentials: true
      },
      data: {
        s:JSON.stringify(payload, null, "\t")
      },
      dataType: "text",
      success: (data) => {
        callbackSuccess(data)
      },
      error: (data) => {
        callbackError(data)
      }
    }
  )

}

export default WebServicePost;
